// extracted by mini-css-extract-plugin
export default {"footer":"AdminFooter_footer__MITmx","footer-content":"AdminFooter_footer-content__7-nlq","footer-text":"AdminFooter_footer-text__9mB5M"};